module.exports = __webpack_public_path__ + "img/icon1.38224e51.png";